export const NEXT_SLOTS = "/api/v1/widget-next-schedule";
